import { Button } from '@trackman/web-shared-components';
import { History } from 'history';
import React from 'react';
import { Content, Description, List, NoDataWrapper, Title } from './styles/NoDataStyles';

interface IProps {
  history: History;
}

const NoData: React.FC<IProps> = (props) => {
  const { history } = props;

  return (
    <NoDataWrapper>
      <Content>
        <Title>No session data available</Title>
        <div>
          <Description>We currently do not have data available for this session. This could be due to:</Description>
          <List>
            <li>
              The session was submitted when the internet signal was weak or nonexistent. Once the device is back online and connected to a
              strong internet, the data will begin to automatically upload. You will see the data for this session once all of the data has
              been uploaded.
            </li>
            <li>The radar was not connected and no data was captured.</li>
          </List>
        </div>
        <Button intent='primary' label='Back to serach results' onClick={() => history.goBack()} width={'fit-content'} />
      </Content>
    </NoDataWrapper>
  );
};

export default NoData;
